
<template>
	<v-card
		elevation="12"
		class="pb-6"
		style="border-top: solid 2px"
		:loading="ChartVentasObjetivo.isLoading"
	>
		<v-card-title
			class="d-flex justify-center"
			style="background-color: #e5e5e5"
		>
			<div
				class="overline"
				style="font-size: 1rem !important; color: black"
			>
				Total de ventas por mes
			</div>
		</v-card-title>
		<v-divider class="test"></v-divider>
		<v-tabs v-model="tab" class="d-flex flex-column" grow>
			<v-tab>Diagrama de lineas</v-tab>
			<v-tab>Diagrama de barras</v-tab>
			<v-tab-item>
				<LineChart
					v-if="!ChartVentasObjetivo.isLoading"
					:chart-data="ChartVentasObjetivo.ventasObjetivo"
					:options="OptionsLineChart"
				></LineChart>
				<v-container v-else fill-height fluid class="text-center">
					<v-progress-circular
						class="mx-auto"
						:size="50"
						:width="5"
						indeterminate
						color="primary"
					></v-progress-circular>
				</v-container>
			</v-tab-item>
			<v-tab-item>
				<HorizontalBar
					v-if="!ChartVentasObjetivo.isLoading"
					:chart-data="ChartVentasObjetivo.ventasObjetivo"
					:options="OptionsBarChart"
				></HorizontalBar>
				<v-container v-else fill-height fluid class="text-center">
					<v-progress-circular
						class="mx-auto"
						:size="50"
						:width="5"
						indeterminate
						color="primary"
					></v-progress-circular>
				</v-container>
			</v-tab-item>
		</v-tabs>
	</v-card>
</template>

<script>
import { mapState } from 'vuex';
import LineChart from './LineChart.js';
import HorizontalBar from './HorizontalBar.js';
export default {
	name: 'StatsVentasMes',
	components: {
		LineChart,
		HorizontalBar,
	},
	data: () => ({
		tab: 0,
		OptionsLineChart: {
			maintainAspectRatio: false,
			responsive: true,
			legend: {
				display: true,
				position: 'top',
				align: 'center',
				labels: {
					padding: 10,
				},
			},
		},
		OptionsBarChart: {
			maintainAspectRatio: false,
			responsive: true,
			legend: {
				display: true,
				position: 'top',
				align: 'center',
				labels: {
					padding: 10,
				},
			},
		},
	}),
	computed: {
		...mapState('statistics', {
			ChartVentasObjetivo: (state) => state.ChartVentasObjetivo,
		}),
	},
};
</script>

<style>
</style>